import React from "react";
import { useTranslation } from "react-i18next";
import "./LocationMap.scss";

const LocationMap = () => {
  const { t } = useTranslation();
  const googlePlaceId = "ChIJe_2SeABDXz4R3-AQv2KrUzI";
  const googleReviewHref = `https://search.google.com/local/writereview?placeid=${googlePlaceId}`;
  const rating = "4.5"; // يمكن تحديثه يدوياً عند الحاجة

  return (
    <section id="location" className="location-map">
      <h2>{t("location.title")}</h2>
      <div className="location-map__wrap">
        <iframe
          title={t("location.mapTitle")}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.622086043926!2d55.28076210000001!3d25.1886255!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43007892fd7b%3A0x3253ab62bf10e0df!2sShawarma%20Dose%20DXB!5e0!3m2!1sen!2sae!4v1719334650000!5m2!1sen!2sae"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
      {/* تحت رابط View larger map مباشرةً */}
      <div className="gm-review-bar">
        <a
          className="gm-review-badge"
          href={googleReviewHref}
          target="_blank"
          rel="noopener noreferrer"
          title={t("location.rateOnGoogle", "Rate us on Google")}
        >
          <span className="gm-review-badge__icon">
            <span className="gm-review-badge__g">G</span>
          </span>
          <span className="gm-review-badge__score">{rating}</span>
          <span className="gm-review-badge__stars" aria-hidden="true">★★★★★</span>
        </a>
      </div>
    </section>
  );
};

export default LocationMap;
